import React, { useState, useEffect } from "react";
import { Editor } from "primereact/editor";
import { useParams, useLocation } from "react-router-dom";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { Layout, Menu, Button, Modal, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../UserContext";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import KnowledgeTest from "./KnowledgeTest";
import Quiz from "./quiz";
import './Course.css';
import ChatBox from "../Chatbot";

const { Header, Sider, Content } = Layout;

const Course = () => {
	const { courseId, moduleId, subModuleId } = useParams();
	const { studentapiuri, token } = useContext(UserContext);
	const [text, setText] = useState("");
	const [CourseContent, setCourseContent] = useState({});
	const [loading, setloading] = useState(false);
	const [currentModule, setCurrentModule] = useState(1);
	const [currentSubmodule, setCurrentSubmodule] = useState(1);
	const [activeMenuKeys, setActiveMenuKeys] = useState([]);
	const [isCourseCompleted, setIsCourseCompleted] = useState(false);
	const [courseData, setCourseData] = useState({});
	const [quizData, setQuizData] = useState({});
	const location = useLocation();
    const [modules, setmodules] = useState({})
    const [articles, setArticles] = useState([])
	const [yt, setyt] = useState([])
	const [tranlate, settranlate] = useState("")
	const [examples, setExamples] = useState([])
	

	const fetchcoursecontent = async () => {
		const response = await fetch(
			`${studentapiuri}/stud/getcoursedetails/${courseId}`,
			{
				method: "GET",
				headers: {
					"content-type": "application/json",
					Authorization: "BEARER " + token,
				},
			}
		);
		console.log(response);
		const data = await response.json();
		console.log(data);
		setCourseData(data.data);
        setmodules(data.modules);
	};

	const GenerateSubContent = async (module, submodule) => {
		setloading(true);
		if (courseData && courseData.courseStructure) {
			module = courseData?.courseStructure[parseInt(currentModule - 1)]?._id;
			submodule =
				courseData?.courseStructure[parseInt(currentModule - 1)]?.subModules[
					parseInt(currentSubmodule - 1)
				]?._id;
		}

		const response = await fetch(
			`${studentapiuri}/stud/getcoursecontent/${courseId}`,
			{
				method: "POST",
				headers: {
					"content-type": "application/json",
					Authorization: "BEARER " + token,
				},
				body: JSON.stringify({
					moduleId: module,
					subModuleId: submodule,
				}),
			}
		);
		const data = await response.json();
		// console.log(data);
		const level = data.level;
        if(data && data.data){
            setText(data?.data[level]);
        }
		setloading(false);
	};

	useEffect(() => {
		fetchcoursecontent();
		
	}, []);

	const GenerateQuizContent = async (module) => {
		setloading(true);
		if (courseData && courseData.courseStructure) {
			module = courseData?.courseStructure[parseInt(currentModule - 1)]?._id;
		}
		const response = await fetch(
			`${studentapiuri}/stud/getqt/${courseId}/${module}`,
			{
				method: "GET",
				headers: {
					"content-type": "application/json",
					Authorization: "BEARER " + token,
				},
			}
		);
		const data = await response.json();
		// console.log(data);
		setQuizData(data?.data?.quizId);
		setloading(false);
	};

    const GenerateArticles = async (submodule) => {
			setloading(true);
			

			const response = await fetch(
				`${studentapiuri}/stud/getarticles/${courseData?.courseStructure[parseInt(currentModule - 1)]?.subModules[
						parseInt(currentSubmodule - 1)
					]?._id}`,
				{
					method: "GET",
					headers: {
						"content-type": "application/json",
						Authorization: "BEARER " + token,
					},
					
				}
			);
			const data = await response.json();
			console.log(data);
			
			if (data && data.data && data.status!==404) {
				setArticles(data.data);
			}
			setloading(false);
		};
    const GenerateYT = async () => {
			setloading(true);
			

			const response = await fetch(
				`${studentapiuri}/stud/getyt/${courseData?.courseStructure[parseInt(currentModule - 1)]?.subModules[
						parseInt(currentSubmodule - 1)
					]?._id}`,
				{
					method: "GET",
					headers: {
						"content-type": "application/json",
						Authorization: "BEARER " + token,
					},
				}
			);
			const data = await response.json();
			console.log(data);
			
			if (data) {
				setyt(data?.data);
			}
			setloading(false);
		};
    const Translate = async (target_lang,source_text) => {
		console.log(target_lang,source_text)
			setloading(true);
			

			const response = await fetch(`https://translatorapi-giwa.onrender.com`, {
				method: "POST",
				headers: {
					"content-type": "application/json",
				},
				body:JSON.stringify({
					source_lang:"en",
					target_lang:target_lang,
					source_text:source_text
				})
			});
			const data = await response.json();
			settranlate(data.translated_text);
			console.log(data.translated_text);
			setloading(false);
		};
    const GenerateExamples = async () => {
			
			setloading(true);

			const response = await fetch(
				`${studentapiuri}/stud/examples/${courseId}/${
					courseData?.courseStructure[parseInt(currentModule - 1)]?.subModules[
						parseInt(currentSubmodule - 1)
					]?._id
				}`,
				{
					method: "GET",
					headers: {
						"content-type": "application/json",
						"Authorization":"BEARER " + token
					},
					
				}
			);
			const data = await response.json();
			setExamples(data);
			console.log(data);
			setloading(false);
		};

	


	

	const fetchModuleSubmodule = () => {
		const parts = location.pathname.split("/");
		const moduleIndex = parseInt(parts[parts.indexOf("module") + 1]);
		const submoduleIndex = parseInt(parts[parts.indexOf("submodule") + 1]);
		setCurrentModule(moduleIndex);
		setCurrentSubmodule(submoduleIndex);
	};
	useEffect(() => {
		fetchModuleSubmodule();
	}, [location.pathname]);



	useEffect(() => {
        if(currentSubmodule){
            GenerateSubContent(currentModule, currentSubmodule);
        }
		GenerateQuizContent(currentModule);
		updateActiveMenuKeys();
	}, [currentModule, currentSubmodule, courseData]);

	

	const updateActiveMenuKeys = () => {
		const parts = location.pathname.split("/");
		const moduleIndex = parseInt(parts[parts.indexOf("module") + 1]);
		const submoduleIndex = parseInt(parts[parts.indexOf("submodule") + 1]);
		setActiveMenuKeys([`sub${moduleIndex}-${submoduleIndex}`]);
	};

    
	return (
		<div>
			<Layout style={{ minHeight: "100vh" }}>
				<Sider
					breakpoint="md"
					collapsedWidth="0"
					className="course-side-menu"
					style={{
						position: "fixed",
					}}>
					<Menu
						mode="inline"
						theme="dark"
						selectedKeys={activeMenuKeys}
						openKeys={
							courseData &&
							courseData.courseStructure &&
							courseData.courseStructure.map(
								(module, index) => `sub${index + 1}`
							)
						}
						className="menu">
						{courseData &&
							courseData.courseStructure &&
							courseData.courseStructure.map((module, index) => (
								<Menu.SubMenu
									disabled={!modules[index].access}
									key={`sub${index + 1}`}
									title={module.moduleName}>
									{module &&
										module.subModules.map((submodule, subIndex) => (
											<Menu.Item
												disabled={!modules[index].access}
												key={`sub${index + 1}-${subIndex + 1}`}>
												{modules[index].access && (
													<Link
														to={`/student/courses/${courseId}/module/${
															index + 1
														}/submodule/${subIndex + 1}`}>
														{submodule.name}
													</Link>
												)}
												{!modules[index].access && <>{submodule.name}</>}
											</Menu.Item>
										))}
									<Menu.Item key={`quiz${index + 1}-quiz`}>
										<Link
											to={`/student/courses/${courseId}/module/${
												index + 1
											}/quiz`}>
											{module.quizId.name}
										</Link>
									</Menu.Item>
								</Menu.SubMenu>
							))}
					</Menu>
				</Sider>
				<Layout>
					<Header className="head">
						<div className="title">
							<Link type="text" to="/student/home">
								LEARN YOUR WAY
							</Link>
						</div>
						<div
							style={{ display: "flex", alignItems: "center" }}
							className="head-icons">
							<Link to={"/"}>
								<UserOutlined />
							</Link>
							<Link to={"/"}>
								<LogoutOutlined />
							</Link>
						</div>
					</Header>
					<Content className="content">
						<div className="course-editor">
							{!currentSubmodule && courseData && courseData.courseStructure ? (
								<>
									<Quiz
										quizdata={quizData}
										module={
											courseData?.courseStructure[parseInt(currentModule - 1)]
												?._id
										}></Quiz>
								</>
							) : (
								<>
									<>
										<Markdown rehypePlugins={[rehypeRaw]}>{text}</Markdown>
										<div style={{ display: "flex", flexDirection: "column" }}>
											<h3>Articles</h3>
											{articles?.articleLinks?.map((item) => {
												return (
													<div>
														<h5>{item.title}</h5>
														<a href={item.link}>{item.link}</a>
													</div>
												);
											})}
											<Button onClick={GenerateArticles}>
												Generate Articles
											</Button>
											<h3>Youtube Videos</h3>
											{yt?.ytLinks?.map((item) => {
												return (
													<div>
														<h3>{item.title}</h3>
														<iframe
															width="560"
															height="315"
															src={item.video_url}
															title="YouTube video player"
															frameborder="0"
															allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
															allowfullscreen></iframe>
													</div>
												)
											})}
											<Button onClick={GenerateYT}>
												Generate Youtube Videos
											</Button>
											<h3>Text to speech</h3>
											<Button>Text To Speech</Button>
											<h3>Examples</h3>
											{examples && examples?.data?.examples?.map((item)=>(
												<h4>{item}</h4>
											))}
											<Button onClick={GenerateExamples}>
												Generate Examples
											</Button>
											<h3>Translate</h3>
											<select id="lang">
												<option value="te">Telugu</option>
												<option value="hi">Hindi</option>
											</select>
											<Button
												onClick={async () =>
													await Translate(
														document.getElementById("lang").value,
														text
													)
												}>
												Translate
											</Button>
											<Markdown rehypePlugins={[rehypeRaw]}>
												{tranlate}
											</Markdown>
										</div>
									</>
								</>
							)}
						</div>
					</Content>
					<ChatBox
						style={{
							position: "fixed",
							right: "10px",
							left: "90vw",
							width: "100px",
							bottom: "50px",
							top: "80vh",
						}}
					/>
				</Layout>
			</Layout>
		</div>
	);
};

export default Course;
